export const PERFORMANCEPREDICATE_LOADING = "PERFORMANCEPREDICATE_LOADING";
export const PERFORMANCEPREDICATE_RESET = "PERFORMANCEPREDICATE_RESET";
export const GET_PERFORMANCEPREDICATE = "GET_PERFORMANCEPREDICATE";
export const GET_PERFORMANCEPREDICATE_SUCCESS = "GET_PERFORMANCEPREDICATE_SUCCESS";
export const GET_PERFORMANCEPREDICATE_FAIL = "GET_PERFORMANCEPREDICATE_FAIL";
export const DELETE_PERFORMANCEPREDICATE = "DELETE_PERFORMANCEPREDICATE"
export const DELETE_PERFORMANCEPREDICATE_SUCCESS = "DELETE_PERFORMANCEPREDICATE_SUCCESS"
export const DELETE_PERFORMANCEPREDICATE_FAIL = "DELETE_PERFORMANCEPREDICATE_FAIL"
export const UPDATE_PERFORMANCEPREDICATE = "UPDATE_PERFORMANCEPREDICATE"
export const UPDATE_PERFORMANCEPREDICATE_SUCCESS = "UPDATE_PERFORMANCEPREDICATE_SUCCESS"
export const UPDATE_PERFORMANCEPREDICATE_FAIL = "UPDATE_PERFORMANCEPREDICATE_FAIL"
export const ADD_NEW_PERFORMANCEPREDICATE = "ADD_NEW_PERFORMANCEPREDICATE"
export const ADD_PERFORMANCEPREDICATE_SUCCESS = "ADD_PERFORMANCEPREDICATE_SUCCESS"
export const ADD_PERFORMANCEPREDICATE_FAIL = "ADD_PERFORMANCEPREDICATE_FAIL"